<script>
    import PlayerModal from './PlayerModal.svelte';
    import BatterTable from "./BatterTable.svelte";
    import PitcherTable from "./PitcherTable.svelte";
    import NoProj from './NoProj.svelte';
    import { onMount } from 'svelte';
    import { getTeams, gameStrings } from './filter_utils.js';
    import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
	import { Swiper, SwiperSlide } from 'swiper/svelte/swiper-svelte.js';
	import GameCard from './GameCard.svelte';
    import 'swiper/swiper-bundle.min.css';
	// swiper core styles
	import 'swiper/swiper.min.css';
	// modules styles
	import 'swiper/modules/navigation/navigation.min.css';
	import 'swiper/modules/pagination/pagination.min.css';
    export let games = [];
    export let players = [];
    export let premium_membership = true;
    export let placeholder_variances = {};
    let teams = [];
    let pos_filter = "all";
    let pitching_batting_select = "pitching";
    let position_filters = ["C", "1B" ,"2B", "3B", "SS", "OF"];
    let selected_team = "all";
    let batters = [];
    let pitchers = [];
    let player_search = "";
    let game_strings = gameStrings(games);
    let modal_player;
    let modal_projection_id;
    function showPlayerModal(player) {
        modal_projection_id = player.stats.proj_id;
        modal_player = player;
        let myModal = new bootstrap.Modal(document.getElementById('player-modal'));
		myModal.show();
    }
    onMount(() => {
		// split players into batters and pitchers
        for (let player of players) {
            if (player.positions.includes("P")) {
                pitchers.push(player);
            } else {
                batters.push(player);
            }
        }
        // add teams in the games
        teams = getTeams(games);
        pitchers = pitchers;
        batters = batters;
	});
</script>
{#if games.length > 0 && players.length > 0}
<PlayerModal placeholder_variances={placeholder_variances} league={'mlb'} player={modal_player} proj_id={modal_projection_id} premium_membership={premium_membership}></PlayerModal>
<div style="background-color:#e9ecef;" class="bg-gradient shadow border-top border-bottom py-2 mb-4">
	<h1 class="ps-2 display-6 lh-1">Games</h1>
	<Swiper
		modules={[Navigation, Pagination, Scrollbar, A11y]}
		spaceBetween={10}
		navigation="{true}"
		pagination={{ clickable: true }}
		breakpoints={{
			320: {
				slidesPerView: 1,
				spaceBetween: 10
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 10
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 10
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 10
			},
			1920: {
				slidesPerView: 5,
				spaceBetween: 10
			}
		}}
	>
		{#each games as game}
		<SwiperSlide><GameCard home_team={game.home_team} away_team={game.away_team} game_time={game.game_time} lines={game.lines}></GameCard></SwiperSlide>
		{/each}
	</Swiper>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div
                class="d-flex h-100 align-items-center btn-group"
                role="group"
                aria-label="Basic radio toggle button group"
            >
                <input
                    type="radio"
                    bind:group={pitching_batting_select}
                    value="pitching"
                    class="btn-check"
                    name="btnradio"
                    id="btnradio1"
                    autocomplete="off"
					checked
                />
                <label class="w-100 btn btn-outline-primary" for="btnradio1">Pitching</label>
                <input
                    type="radio"
                    bind:group={pitching_batting_select}
                    class="btn-check"
                    name="btnradio"
                    id="btnradio2"
                    value={"batting"}
                    autocomplete="off"
                />
                <label class="w-100 btn btn-outline-primary" for="btnradio2">Batting</label>
            </div>
        </div>
        <div class="{pitching_batting_select === 'pitching' ? 'col-md-6' : 'col-lg-4'} pb-1 mt-auto">
            <label for="team-select">Filter By Team</label>
            <select bind:value={selected_team}  class="form-select form-select-lg" id="team-select">
                <option value="all">All</option>
                {#each teams as team}
                    <option value="{team.short_name}">{team.city_name} {team.mascot_name}</option>
                {/each}
            </select>
        </div>
        <div class="{pitching_batting_select === 'pitching' ? 'd-none' : 'col-lg-4'} pb-1 mt-auto">
            <div class="d-flex h-100 align-items-center btn-group" role="group" aria-label="Basic radio toggle button group">
            <input type="radio" bind:group={pos_filter} value="all" class="btn-check" name="pos-radio" id="posradio1" autocomplete="off" checked>
            <label class="w-100 btn btn-outline-primary" for="posradio1">All</label>
            {#each position_filters as position, index}
            <input type="radio" bind:group={pos_filter} class="btn-check" name="pos-radio" id="posradio{index+2}" value="{position}" autocomplete="off">
            <label class="w-100 btn btn-outline-primary" for="posradio{index+2}">{position}</label>
            {/each}
            </div>
        </div>
        <div class="{pitching_batting_select === 'pitching' ? 'col-md-6' : 'col-lg-4'} pb-1 mt-auto">
            <div class="input-group input-group-lg">
                <span class="input-group-text" id="inputGroup-sizing-lg">🔍</span>
                <input bind:value={player_search} autocomplete="off" id="player-search" type="text" class="form-control" aria-label="Sizing example input" placeholder="Search for a Player..." aria-describedby="inputGroup-sizing-lg">
            </div>
        </div>
    </div>
    {#if pitching_batting_select == "pitching"}
        <PitcherTable pitchers={pitchers} player_search={player_search} selected_team={selected_team} game_strings={game_strings} showPlayerModal={showPlayerModal}/>
    {:else}
        <BatterTable batters={batters} player_search={player_search} selected_team={selected_team} pos_filter={pos_filter} game_strings={game_strings} showPlayerModal={showPlayerModal}/>
    {/if}
</div>
{:else}
<NoProj league={"MLB"} logo_url={window.logo_url}></NoProj>
{/if}